import { AnyAction } from 'redux'
import * as actionType from './user.types'
import { UserState } from './user.reducer'

export const setUser = (user: any): AnyAction => ({ type: actionType.SET_USER, payload: { user } })
export const resetUser = (): AnyAction => ({ type: actionType.RESET_USER })
